import { useQuery } from '@tanstack/react-query';
import { makeRequest } from 'features/entry-form-v2/data/makeRequest';

type GetDatasetRowsResponse = {
	totalCount: number;
};

// Unfiltered total entry count for the dataset (filters omitted on purpose).
export function useTotalEntryCount(projectId: string, options?: { enabled?: boolean }) {
	return useQuery({
		queryKey: ['export-codelist', 'total-entry-count', projectId],
		enabled: options?.enabled ?? true,
		queryFn: () =>
			makeRequest<GetDatasetRowsResponse>({
				method: 'getDatasetRowsV2',
				service: 'stats',
				data: {
					projectId: Number(projectId),
					filters: [],
					maxPageSize: 1,
					startAt: 0
				}
			})
	});
}
